var _ = require('underscore');
module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="CDB-Widget-canvasInner js-container"></div>\n';

}
return __p
}